import React, { lazy, Suspense } from "react";
const LogMessagesAdmin = lazy(() =>
  import("../../features/reports/admin/logmessages/components/LogMessagesAdmin"),
);
import Loading from "../../components/ui/Suspense";
const _Reports = () => {
  return (
    <Suspense fallback={<Loading />}>
        <h2>Registro de Mensajes SMS</h2>
      <LogMessagesAdmin />
    </Suspense>
  );
};

export default _Reports;
